module.exports = __webpack_public_path__ + "static/media/ae.998cc1fc.svg";